var exports = {
  "nV": "x61f99309--c2d7bd--gallery",
  "Sl": "x61f99309--c2d7bd--image",
  "Nd": "x61f99309--c2d7bd--gallery--reverse",
};

module.exports = exports;
